import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Footer.css';

const Footer = () => {
    const year = new Date().getFullYear();

    const navLinks = [
        { label: 'About', href: '#about' },
        { label: 'Skills', href: '#skills' },
        { label: 'Projects', href: '#projects' },
        { label: 'Experience', href: '#experience' },
        { label: 'Contact', href: '#contact' },
    ];

    const socials = [
        { label: 'GH', href: 'https://github.com/nandanannn24' },
        { label: 'LI', href: 'https://linkedin.com/in/priyoga-listyo-ananda' },
        { label: 'IG', href: 'https://www.instagram.com/_nandanannn' },
    ];

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-top">
                    <div className="footer-brand">
                        <h3>Nanda</h3>
                        <p>Crafting digital experiences with purpose and precision.</p>
                    </div>
                    <div className="footer-nav">
                        {navLinks.map((l, i) => (
                            <a key={i} href={l.href}>{l.label}</a>
                        ))}
                    </div>
                </div>
                <div className="footer-divider" />
                <div className="footer-bottom">
                    <p>&copy; {year} Nanda. All rights reserved.</p>
                    <div className="footer-status">
                        {socials.map((s, i) => (
                            <motion.a
                                key={i}
                                href={s.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                whileHover={{ y: -2 }}
                            >
                                {s.label}
                            </motion.a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;